import React, { useEffect, useState } from "react";
import umanizzaDataSenzaOre from "../../../interfaccia/funzioniComuni/umanizzaDataSenzaOre";
import ImgArt from "./ImgArt";
import ZoomableImage from "../../../interfaccia/ZoomableImage";
import apiUrl from "../../../Apiurl";

function RiquadrinoOrdine({
  ordine,
  impostaOrdine,
  mostraArticoli = false,
  token,
  articoliOverride,
  mostraStato = true,
  mostraDate = true,
  mostraMagazzino = true,
  mostraTipo = true,
  mostraCliente = true,
  mostraIdPS = true,
  iconaApriOrdineSuCliente = false,
  classeSfondo = "",
}) {
  const [articoliLocal, setArticoliLocal] = useState(
    articoliOverride ||
      ordine.articoliArr ||
      ordine.articoli ||
      ordine.articoliOrdine ||
      []
  );

  let classStato = "";

  switch (ordine["Stato_Ordine"]) {
    case "IN ATTESA":
      classStato = "colAttesa";
      break;
    case "SPEDITO":
      classStato = "colSpedito";
      break;
    case "PREPARAZIONE":
      classStato = "colPreparazione";
      break;
    case "ETICHETTE":
      classStato = "colEtichette";
      break;
    case "PRONTO EXP":
      classStato = "colProntoExp";
      break;
    case "ANNULLATO":
      classStato = "colAnnullato";
      break;
    case "IN ATTESA BB":
      classStato = "colBonifico";
      break;
    case "RESO":
      classStato = "colReso";
      break;
    case "RESO - WARRANTY":
      classStato = "colResoW";
      break;
    default:
      break;
  }

  const magazzinoClass = (value) => {
    const val = (value || "").toString().toLowerCase();
    if (!val) return "";
    if (val.startsWith("proshop")) return "bg-dark-green white";
    if (val === "prato nevoso") return "bg-blue white";
    if (val === "vernante") return "bg-dark-red white";
    if (val === "torino") return "bg-navy white";
    if (val === "villanova mondovì" || val === "villanova mondovi")
      return "bg-light-purple white";
    if (val.includes("ritiro")) return "bg-washed-red";
    return "";
  };

  useEffect(() => {
    if (articoliOverride) {
      setArticoliLocal(articoliOverride);
      return;
    }
    setArticoliLocal(
      ordine.articoliArr || ordine.articoli || ordine.articoliOrdine || []
    );
  }, [ordine, articoliOverride]);

  useEffect(() => {
    if (!mostraArticoli) return;
    if ((articoliLocal || []).length > 0) return;
    if (!token || !ordine?.["ID Spedizione"] || articoliOverride) return;

    const controller = new AbortController();
    const fetchArticoli = async () => {
      try {
        const res = await fetch(
          `${apiUrl}/logistica/ricerca/ricOrdineCodSpedQuerySep/${ordine["ID Spedizione"]}`,
          {
            headers: { Authorization: "Bearer " + token },
            signal: controller.signal,
          }
        );
        const data = await res.json();
        const articoli =
          data?.articoliArr || data?.articoli || data?.articoliOrdine || [];
        if (articoli.length) {
          setArticoliLocal(articoli);
        }
      } catch (err) {
        if (controller.signal.aborted) return;
        console.error("Errore fetch articoli riquadrino", err);
      }
    };
    fetchArticoli();
    return () => controller.abort();
  }, [mostraArticoli, articoliLocal, token, ordine]);

  const renderCell = ({
    label,
    value,
    width = "w-50",
    className = "",
    onClick,
    valuePrefix,
  }) => {
    const cellClass =
      `${width} tc bordoColAlt pa2 ` + (className ? className : "");
    const hasPrefix = Boolean(valuePrefix);
    const bodyClass = hasPrefix ? "tl" : "tc w-100";
    return (
      <div className={cellClass} onClick={onClick}>
        <div className="flex items-center justify-center">
          {hasPrefix && (
            <span className="flex items-center mr2">{valuePrefix}</span>
          )}
          <div className={bodyClass}>
            <div>{label}</div>
            <strong>{value}</strong>
          </div>
        </div>
      </div>
    );
  };

  const nomeCliente = ordine.nomeCliente || ordine.nomeCognomeSpedizione || "-";
  const idPS = ordine?.["N_rif_PrestaShop"] || "-";
  const hasCliente = mostraCliente;
  const hasIdPS = mostraIdPS;
  const widthBase = hasCliente && hasIdPS ? "w-50" : "w-100";
  const apriOrdineIcona = impostaOrdine ? (
    <span className="material-icons colScrittaDef-20 mr2">
      open_in_new
    </span>
  ) : null;

  return (
    <div
      className={
        "sfondoBiancoTema br4 pa2 flex flex-wrap mb3 mw6 " + classeSfondo
      }
    >
      {(mostraCliente || mostraIdPS) && (
        <div className="flex w-100 bb bordoColAlt">
          {mostraCliente &&
            renderCell({
              label: mostraArticoli ? "CLIENTE" : "DESTINATARIO",
              value: nomeCliente,
              width: widthBase,
              className: !mostraArticoli && impostaOrdine ? "pointer dim" : "",
              onClick:
                !mostraArticoli && impostaOrdine
                  ? (e) => impostaOrdine(e, ordine["ID Spedizione"])
                  : undefined,
              valuePrefix: iconaApriOrdineSuCliente ? apriOrdineIcona : null,
            })}
          {mostraIdPS &&
            renderCell({
              label: "ORDINE PS",
              value: idPS,
              width: widthBase,
              className: impostaOrdine ? "pointer dim" : "",
              onClick: impostaOrdine
                ? (e) => impostaOrdine(e, ordine["ID Spedizione"])
                : undefined,
              valuePrefix: !iconaApriOrdineSuCliente ? apriOrdineIcona : null,
            })}
        </div>
      )}
      {mostraArticoli && (
        <div className="w-100 pv2">
          {Array.isArray(articoliLocal) && articoliLocal.length > 0 ? (
            articoliLocal.map((articolo, idx) => {
              const descrizione =
                articolo?.["Descrizione Articolo"] ||
                articolo?.descrizioneArticolo ||
                articolo?.descA ||
                articolo?.desc ||
                "-";
              const quantita =
                articolo?.["Quantità"] ??
                articolo?.quantita ??
                articolo?.qta ??
                articolo?.quant ??
                articolo?.qty;
              const codice =
                articolo?.["Cod Viglietti Sport"] ||
                articolo?.codVS ||
                articolo?.codiceVS ||
                articolo?.codiceArticolo ||
                articolo?.codice_articolo;
              const imgSrc =
                articolo?.immagine ||
                articolo?.img ||
                articolo?.img_preview ||
                articolo?.image ||
                articolo?.link_immagine;
              const imgId = articolo?.imgIDps;
              const prodId = articolo?.prodIDps;
              return (
                <div
                  key={idx}
                  className="flex w-100 mb2 pb2 bb b--black-10 items-center"
                >
                  <div className="w-30 pr2">
                    {codice || (prodId && imgId) ? (
                      <ImgArt
                        prodIDps={prodId}
                        imgIDps={imgId}
                        size={"cart_default"}
                        fonte={articolo?.fonte || articolo?.fonteOrdine || ordine?.fonte}
                        codVS={codice}
                        token={token}
                      />
                    ) : imgSrc ? (
                      <ZoomableImage
                        src={imgSrc}
                        alt={descrizione || codice || "Articolo"}
                        className="w-100 br2"
                      />
                    ) : (
                      <div className="w-100 h3 bg-light-gray br2 flex items-center justify-center f7 gray">
                        {imgId ? `imgIDps ${imgId}` : "Nessuna immagine"}
                      </div>
                    )}
                  </div>
                  <div className="w-70 pl2">
                    <div className="b mb2">
                      {quantita ? `${quantita} pz.` : ""}{" "}
                      {codice ? ` ${codice}` : ""}
                    </div>
                    <div>{descrizione}</div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="gray f7">Nessun articolo disponibile</div>
          )}
        </div>
      )}
      {mostraStato && (
        <div className="flex w-100 bb bordoColAlt">
          {renderCell({
            label: "STATO",
            value: ordine["Stato_Ordine"] || "-",
            width: "w-100",
            className: classStato,
          })}
        </div>
      )}
      {(mostraDate || mostraTipo) && (
        <div className="flex w-100 bb bordoColAlt">
          {mostraDate &&
            renderCell({
              label: "DATA ORDINE",
              value: ordine.dataOrd
                ? umanizzaDataSenzaOre(ordine.dataOrd)
                : "-",
              width: mostraTipo ? "w-50 br" : "w-100",
            })}
          {mostraTipo &&
            renderCell({
              label: "TIPO",
              value: ordine["Tipo"] || "-",
              width: mostraDate ? "w-50" : "w-100",
            })}
        </div>
      )}
      {(mostraDate || mostraMagazzino) && (
        <div className="flex w-100 bb bordoColAlt">
          {mostraDate &&
            renderCell({
              label: "DATA PARTENZA",
              value: ordine["Data_partenza"]
                ? umanizzaDataSenzaOre(ordine["Data_partenza"])
                : "-",
              width: mostraMagazzino ? "w-50 br" : "w-100",
            })}
          {mostraMagazzino &&
            renderCell({
              label: "MAGAZZINO PARTENZA",
              value: ordine["Partenza_da"] || "-",
              width: mostraDate ? "w-50" : "w-100",
              className: magazzinoClass(ordine["Partenza_da"]),
            })}
        </div>
      )}
      {ordine.tracking && (
        <div className="flex w-100 bordoColAlt">
          {renderCell({
            label: "TRACKING",
            value: ordine.tracking,
            width: "w-100",
          })}
        </div>
      )}
    </div>
  );
}

export default RiquadrinoOrdine;

/* 
dataOrd={ordine.dataOrd}
dataPart={ordine["Data_partenza"]}
tipo={ordine.tipo}
nomeCognomeSpedizione={ordine.nomeCognomeSpedizione}
statoOrdine={ordine["Stato_Ordine"]}
tracking={ordine.tracking}
partenzaDa={ordine["Partenza_da"]} */
